import { NavItemService } from '@/services/api/nav-item.service';
import { PermsService } from '@/services/api/perms.service';
import { Component, inject, OnInit } from '@angular/core';
import { Observable, Subscription, tap } from 'rxjs';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { RolesService } from '@/services/api/roles.service';
import { PermRole } from '@/models/user-data.model';
import { TableModule } from 'primeng/table';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { RoleEditorComponent } from './role-editor.component';

@Component({
  selector: 'app-role-items',
  imports: [CommonModule, TableModule, DialogModule, RoleEditorComponent],
  template: `
  <p-table [value]="rolesService.roles()" selectionMode="single" [(selection)]="selectedRole" (onRowSelect)="editRole($event.data)" dataKey="PermRoleID" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template #header>
            <tr>
            <th pSortableColumn="RoleName" class="modName">Role<p-sortIcon field="RoleName"></p-sortIcon></th>
            <th pSortableColumn="Franchises.CityCode" class="modName">Office<p-sortIcon field="Franchises.CityCode"></p-sortIcon></th>
            <th class="modName">Users</th>
            <th class="modButton"></th>
            </tr>
            </ng-template>
        <ng-template #body let-role let-ri="rowIndex">
            <tr [pSelectableRow]="role">

                <td class="engName">
                    {{role.RoleName}}
                </td>
                <td class="engName">
                    {{role.Franchises?.CityCode ?? 'Corporate'}}
                </td>
                <td class="engName">
                    {{role.UserRoles.length}}
                </td>
                <td class="modButton">
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button pButton pRipple type="button" icon="pi pi-trash" (click)="confirmDeleteRole(role)" class="p-button-danger p-button-rounded p-button-text"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog #addRoleDialog [(visible)]="roleDialog" 
  [header]="selectedRole ? 'Edit Role' : 'Add Role'"
  [style]="{ width: '90vw', height: '85vh' }"
  [modal]="true"
  styleClass="p-fluid">
  <app-role-editor (submitted)="roleSaved()" [navItems]="navItemsService.navItems()" [editMode]="roleDialog"></app-role-editor>
</p-dialog>
  `,
  styles: `
  
  `
})
export class RoleItemsComponent {
  activeIndex: number = 0;
  selectedRole: PermRole | null = null;
  roleDialog: boolean = false;

  public rolesService= inject(RolesService);
  public confirmationService= inject(ConfirmationService);
  public messageService= inject(MessageService);
  public navItemsService= inject(NavItemService);

  constructor(
  ) { }

  confirmDeleteRole(role: PermRole) {
    const roleId = role.PermRoleID;
    const roleName = role.RoleName
    this.confirmationService.confirm({
      message: `'Do you want to delete '${roleName}'?'`,
      header: 'Delete Role',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.removeRole(roleId).subscribe(
          () => {
            this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Role Removed' });
          },
          (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not remove Role' });
            console.error('Error Deleting Role:', error);
          }
        );
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.CANCEL:
            // this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });
  }

  roleSaved() {
    this.roleDialog = false;
    this.rolesService.populateRoles();
  }

  removeRole(roleId: number): Observable<any> {
    return this.rolesService.removeRole(roleId).pipe(
      tap(removedRole => {
            this.rolesService.populateRoles();
      })
    );
  }

  editRole(role:PermRole) {
    console.log(role)
    this.rolesService.selectedRole.set(role);
    this.roleDialog = true
  }

  addNew() {
    this.roleDialog = true;
  }

}
